import { getBusinessDateString, parseBusinessDate } from '@vista/omnichannel-components-domain';
import { eachDayOfInterval, isToday as isDateToday, max, min } from 'date-fns';
export const getDatePickerDateValues = (businessDates, selectedBusinessDate, i18n) => {
    if (businessDates.length === 0)
        return [];
    const parsedBusinessDates = businessDates.map(parseBusinessDate);
    const allDates = eachDayOfInterval({
        start: min([...parsedBusinessDates, new Date(Date.now())]),
        end: max(parsedBusinessDates)
    });
    return allDates.map(date => {
        const businessDate = i18n.date(date, { format: 'YYYY-MM-DD' });
        return {
            businessDate: getBusinessDateString(date),
            isActive: businessDates.includes(businessDate),
            isSelected: businessDate === selectedBusinessDate,
            isToday: isDateToday(date)
        };
    });
};
